module.exports = __webpack_public_path__ + "img/ploss-ra.fbda478b.png";